<template>
    <v-app-bar
      app
      dark
      color="primary"
      :clipped-left="$vuetify.breakpoint.smAndUp"
      dense
    >
        <v-app-bar-nav-icon
            @click.stop="changeDrawerVisibility"
        ></v-app-bar-nav-icon>

        <v-toolbar-title>
            <v-img
                :src="require('@/assets/logo_white.png')"
                class="login_image"
                alt="Tasklaw - Software Jurídico"
                width="130px"
            ></v-img>
        </v-toolbar-title>

        <v-divider
            class="mx-3"
            inset
            vertical
        ></v-divider>

        <locale-switch/>

        <!-- <v-toolbar-items class="shidden-sm-and-down">
            <v-toolbar-items>
                <template v-for="menu in menus">
                    <v-btn
                        v-if="(menu.title && $helpers.isPrivate(menu))"
                        text
                        rel="noopener"
                        :to="!menu.href ? { name: menu.name } : null"
                        :href="menu.href"
                        :disabled="menu.disabled"
                        :target="menu.target"
                        :key="menu.name"
                        x-small
                    >
                        <v-badge
                            v-if="menu.badge && menu.badge.value > 0"
                            color="green"
                            :content="menu.badge.value"
                            left
                            overlap
                        >
                            <v-icon class="menu-icon">{{ menu.icon }}</v-icon>
                        </v-badge>
                        <v-icon v-else class="menu-icon">{{ menu.icon }}</v-icon>
                        {{ menu.title }}
                    </v-btn>
                </template>
            </v-toolbar-items>
        </v-toolbar-items> -->

        <v-spacer></v-spacer>

        <v-btn icon @click="handleFullScreen()">
            <v-icon v-if="!fullscreen">fullscreen</v-icon>
            <v-icon v-else>fullscreen_exit</v-icon>
        </v-btn>

        <v-toolbar-title class="mx-3">
            {{ getUserCompany().client.name }}
        </v-toolbar-title>

        <v-menu offset-y bottom left>
            <template v-slot:activator="{ on }">
                <v-btn icon text v-on="on">
                    <v-avatar size="30" :color="avatar.color">
                        <img v-if="avatar.url !== undefined" :src="avatar.url" :alt="avatar.name">
                        <span class="white--text avatar--letter" v-else>{{ avatar.name | initialName }}</span>
                    </v-avatar>
                </v-btn>
            </template>
            <v-list class="pa-0">
                <v-list-item
                    ripple="ripple"
                    rel="noopener"
                    v-for="(menu,index) in companies"
                    :key="index"
                    @click="setUserCompany(menu)"
                >
                    <v-list-item-content class="ml-1">
                        <v-list-item-title v-text="menu.client.name"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-list class="pa-0">
                <v-list-item
                    ripple="ripple"
                    rel="noopener"
                    v-for="(menu,index) in menuAvatar"
                    :key="index"
                    :to="!menu.href ? { name: menu.name } : null"
                    :href="menu.href"
                    :target="menu.target"
                    :disabled="menu.disabled"
                    @click="actions(menu.click)"
                >
                    <v-list-item-icon v-if="menu.icon">
                        <v-icon v-text="menu.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="ml-1">
                        <v-list-item-title v-text="menu.title"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import LocaleSwitch from './LocaleSwitch.vue'

export default {
    components: { LocaleSwitch },
    name: 'app-bar',
    props: ['menus', 'drawer'],
    data: () => ({
        fullscreen: false,
        avatar: {
            url: undefined,
            name: '',
            color: ''
        },
        isEmployee: undefined,
        menuAvatar: [
            {
                icon: 'exit_to_app',
                href: '#',
                title: 'Logout',
                click: 'logout'
            }
        ]
    }),
    computed: {
        companies () {
            let companies = JSON.parse(localStorage.getItem('companies'))
            return companies
        }
    },
    mounted () {
        if (localStorage.profile) {
            const localProfile = JSON.parse(localStorage.profile)
            const currentUserCompany = JSON.parse(localStorage.currentUserCompany)
            this.avatar.name = localProfile.name
            this.avatar.url = (currentUserCompany.profile?.avatar) ? currentUserCompany.profile?.avatar?.url : undefined
            this.avatar.color = currentUserCompany.profile?.color ?? '#2980b9'
            this.isEmployee = currentUserCompany.permissions.isEmployee
        }
    },
    methods: {
        changeDrawerVisibility () {
            this.$emit('update:drawer', !this.drawer)
        },
        handleFullScreen () {
            this.$helpers.toggleFullScreen()
            this.fullscreen = !this.fullscreen
        },
        setUserCompany (userCompany) {
            localStorage.setItem('currentUserCompany', JSON.stringify(userCompany))
            this.$forceUpdate()
            this.$router.go(0)
        },
        getUserCompany () {
            return this.$helpers.getUserCompany()
        },
        actions (action) {
            let vm = this
            const actions = { logout () { vm.logout() } }
            const actionFunction = actions[action]
            actionFunction()
        },
        logout () {
            window.getApp.logout = true
        }
    }
}
</script>

<style lang="stylus" scoped>
    .menu-icon
        margin-right: 10px

    .avatar--letter
        font-size: 1.5em
</style>
